// assets/wishlist.js

(function () {
  const STORAGE_KEY = 'rossella_shopify_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  async function persistToCart(ids) {
    // send a comma‑separated string into cart.attributes.wishlist
    const payload = { attributes: { wishlist: ids.join(',') } };
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.error('Could not update cart attributes', err);
    }
  }

  async function saveWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    await persistToCart(ids);
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  }

  window.Wishlist = {
    isInWishlist: (id) => getWishlist().includes(id),
    add: (id) => {
      let list = getWishlist();
      if (!list.includes(id)) {
        list.push(id);
        saveWishlist(list);
      }
    },
    remove: (id) => {
      let list = getWishlist().filter((x) => x !== id);
      saveWishlist(list);
    },
    toggle: (id) => {
      Wishlist.isInWishlist(id) ? Wishlist.remove(id) : Wishlist.add(id);
    },
    list: () => getWishlist(),
  };
})();

document.addEventListener('click', (e) => {
  // look for clicks on ANY .btn-wishlist or its children
  const btn = e.target.closest('.btn-wishlist');
  if (!btn) return;

  const id = btn.dataset.wishProductId;
  Wishlist.toggle(id);
});

// helper to refresh all buttons’ state
function refreshWishlistButtons() {
  document.querySelectorAll('.btn-wishlist').forEach((btn) => {
    const id = btn.dataset.wishProductId;
    btn.classList.toggle('in-wishlist', Wishlist.isInWishlist(id));
  });
}

document.addEventListener('DOMContentLoaded', refreshWishlistButtons);
document.addEventListener('wishlist:updated', refreshWishlistButtons);
